import { Vue, Watch, Prop } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import IConfigService  from "fs-pb-vue2/services/config/IConfigService";
import { ShowcasePageData } from "fs-pb-vue2/data/showcasePageData";
import { ShowcaseData } from "fs-pb-vue2/data/showcaseData";
import { ShowCaseActionType } from "fs-pb-vue2/data/enums/showCaseActionType";
import { container } from "@/inversify.config";
import { DiTokens } from "fs-pb-vue2/services/diTokens";
import { ConfigStore } from "fs-pb-vue2/store/modules/config";
import { OperationRequestData } from "fs-pb-vue2/data/operationRequestData";
import { OperationsApi } from "fs-pb-vue2/services/api/OperationsApi";
import { ShowcaseDepositData } from "fs-pb-vue2/data/showcaseDepositData";
import { DeclarationPropertiesTypes } from "fs-pb-vue2/data/enums/declarationPropertiesTypes";
import { sumFilter } from "fs-pb-vue2/filters";

export class ShowCaseDepositsListVueGB extends Vue {

  // @Watch("configStore.apiData.ShowcaseFile", { immediate: true })
  // async onShowcaseFileChanged(newVal: string, oldVal: string) {
  //   if (newVal !== oldVal) {
  //     this.depoList = await this.getDepositsList();
  //   }
  // }

  searchSum: number = 0;

  searchPeriod: number = 0;

  showFilterTitle: boolean = false;

  async refreshList(val: any): Promise<void> {
    if (val !== null) {
      this.searchSum = this.getSearchSumFromFilterItem(val);
      this.searchPeriod = val.periodValue ?? 0;
      this.depoList = await this.getDepositsList(val);
    }
  }

  depoList: Array<ShowcaseDepositData> = [];

  listLoading: boolean = false;

  @Prop() pageObj!: ShowcasePageData;

  async getDepositsList(filterItem: any = null): Promise<Array<ShowcaseDepositData>> {
    const resArr: Array<ShowcaseDepositData> = [];
    this.listLoading = true;
    try {
      const ord: OperationRequestData = new OperationRequestData();
      if (this.pageObj && this.pageObj.Data) {
        ord.respondentCode = this.pageObj.Data.respondentCode;
        const sum: any = filterItem ?
          Number(
            filterItem.sumValue.toString().substring(0, filterItem.sumValue.toString().length -2).replaceAll(' ', '').replaceAll(',', '.')
          ) : '';

        ord.setProperty(
          'sum',
          sum.toString(),
          DeclarationPropertiesTypes.Decimal
        );
        ord.setProperty('period', filterItem ? filterItem.periodValue.toString() : '0', DeclarationPropertiesTypes.Int);
        ord.setProperty('deposit', filterItem ? filterItem.depositValue.toString() : '0', DeclarationPropertiesTypes.Boolean);
        ord.setProperty('draft', filterItem ? filterItem.draftValue.toString() : '0', DeclarationPropertiesTypes.Boolean);

        const executeResp: OperationRequestData = await OperationsApi.executeOperationSendAsync(ord);

        if (executeResp && executeResp.listObjects) {
          for (const key in executeResp.listObjects) {
            const item: any = executeResp.listObjects[key];
            if (item) {
              resArr.push(new ShowcaseDepositData(item.Properties));
            }
          }
        }
      }
    } catch (e: any) {
      console.log(e.message);
    }
    this.listLoading = false;
    return resArr;
  }

  callDetailAction(item: ShowcaseDepositData): void {
    if (item) {
      const showCase: ShowcaseData = new ShowcaseData({ actionType: item.DetailActionType, actionLink: item.DetailActionLink });
      this.callAction(showCase);
    }
  }

  callAction(item: ShowcaseData, deposit: ShowcaseDepositData | null = null): void {
    if (item) {
      switch (item.ActionType) {
        case ShowCaseActionType.Close:
          console.log('Close action');
          break;
        case ShowCaseActionType.OpenLinkInApp: {
          let query: string = '';
          if (item.ActionLink.includes('operation/') && deposit) {
            if ([31, 91, 181, 365, 730, 1097, 1830].indexOf(this.searchPeriod) === -1)
              query = 
                `?type=${deposit.DepType}${this.searchSum > 0 ? `&sum=${this.searchSum}` : ''}&periodDays=${this.searchPeriod}`
            else
              query = 
                `?type=${deposit.DepType}${this.searchSum > 0 ? `&sum=${this.searchSum}` : ''}${this.searchPeriod > 0 ? `&periodType=${this.searchPeriod}&periodDays=${this.searchPeriod}` : ''}`
          }
          this.$router.push(`/${item.ActionLink}${query}`)
          break;
        }
        case ShowCaseActionType.OpenLinkInBrowser: {
          window.open(this.$options.filters.url(item.ActionLink), '_blank');
          break;
        }
        case ShowCaseActionType.DownloadFile: {
          const a = document.createElement("a");
          a.setAttribute('href', item.ActionLink);
          a.setAttribute('target', '_blank');
          a.setAttribute('download', item.ActionLink.substring(item.ActionLink.lastIndexOf('/')));
          a.click();
          a.remove();
          break;
        }
        default:
          console.log('None action');
          break;
      }
    }
  }

  // Метод для получения суммы из filterItem
  getSearchSumFromFilterItem(filterItem: any): number {
    if (filterItem && filterItem.sumValue) {
      const sumStr: string = filterItem.sumValue.toString().replace(',', '.').replaceAll(' ', '');
      return parseFloat(sumStr);
    }
    return 0;
  }

  // Строка с указанием процентов по вкладу
  incomePercStr(deposit: ShowcaseDepositData): string {
    if (deposit.IncomePerc > 0) {
      if (deposit.IncomePercCapital != 0) {
        return `${deposit.IncomePerc}% / ${deposit.IncomePercCapital}%`;
      } else {
        return `${deposit.IncomePerc}%`;
      }
    } else {
      return `до ${deposit.Persent}%`;
    }
  }

  // Описание для поля процентов по вкладу
  incomePercDescriptionStr(deposit: ShowcaseDepositData): string {
    if (deposit.IncomePercCapital != 0) {
      return "процентная ставка (без / с капитализацией)";
    } else {
      return "процентная ставка";
    }
  }

  // Строка с указанием суммы в конце срока вклада
  resultSumStr(deposit: ShowcaseDepositData): string {
    if (deposit.IncomePercCapital != 0) {
      return `${sumFilter(this.searchSum + deposit.IncomeSum)} руб. / ${sumFilter(this.searchSum + deposit.IncomeSumCapital)} руб.`;
    } else {
      return `${sumFilter(this.searchSum + deposit.IncomeSum)}р`;
    }
  }

  // Описание для поля суммы в конце срока
  resultSumDescriptionStr(deposit: ShowcaseDepositData): string { 
    if (deposit.IncomePercCapital != 0) {
      return "сумма в конце срока (без / с капитализацией)";
    } else {
      return "сумма в конце срока";
    }
  }

  // Строка с указанием дохода по вкладу
  incomeSumDescription(deposit: ShowcaseDepositData): string { 
    if (deposit.IncomePercCapital != 0) {
      return `${sumFilter(deposit.IncomeSum)} руб. / ${sumFilter(deposit.IncomeSumCapital)} руб.`;
    } else {
      return `${sumFilter(deposit.IncomeSum)} руб.`;
    }
  }

  // Описание для поля дохода по вкладу
  incomeSumDescriptionText(deposit: ShowcaseDepositData): string { 
    if (deposit.IncomePercCapital != 0) {
      return "доход по вкладу (без / с капитализацией)";
    } else {
      return "доход по вкладу";
    }
  }

  // Признак отображения суммы по истечении срока вклада
  searchDepositIncome(deposit: ShowcaseDepositData): boolean { 
    return this.searchSum > 0 && deposit.IncomeSum > 0;
  }

  depositAmount(deposit: ShowcaseDepositData): string {
    if (this.searchSum) {
      return `${sumFilter(this.searchSum)} руб.`;
    } else {
      return deposit.Summa;
    }
  }
}
